// Guardar las columnas propias de una tabla que viven en
// `AgencySetting.tableCustomColumns` (Renovaciones, Prospecto y Referido,
// Comisiones por póliza). Una sola función para las tres pantallas: las tres
// tenían el mismo guardado que reemplazaba la lista entera (ticket de Marilyn
// Sequera, 2026-10-28). La regla de qué se conserva vive en
// `customColumns.js#fusionarColumnas`, que se puede probar sin navegador.
import { getAgencySettings, updateAgencySettings } from './api.js';
import { fusionarColumnas, normalizeColumns } from './customColumns.js';

/**
 * @param {string} modulo   'renewals' | 'onboarding' | 'commissions' …
 * @param {Array} alAbrir   las columnas que la ventana recibió al abrirse
 * @param {Array} editadas  las que devolvió al guardar
 * @returns las columnas tal y como quedaron guardadas
 */
export async function guardarColumnasDeTabla(modulo, alAbrir, editadas) {
  // Si no se puede leer lo guardado AHORA, no se guarda: guardar a ciegas era
  // reemplazar las columnas de TODAS las tablas por las de esta sola. El error
  // sale en la ventana de columnas, que no se cierra.
  const ajustes = await getAgencySettings();
  const tablas = (ajustes && typeof ajustes.tableCustomColumns === 'object' && ajustes.tableCustomColumns) || {};
  const final = fusionarColumnas(alAbrir, editadas, tablas[modulo]);
  const guardado = await updateAgencySettings({ tableCustomColumns: { ...tablas, [modulo]: final } });
  return normalizeColumns(guardado?.tableCustomColumns?.[modulo] ?? final);
}

/**
 * Lo mismo para las tablas cuyas columnas viven en su PROPIA clave de los
 * ajustes (Baúl, Info de Empresa, Pagos del Mes, Seguimientos). Tenían el mismo
 * guardado que reemplazaba la lista entera.
 *
 * @param {string} clave  'vaultCustomColumns' | 'companyCustomColumns' | …
 */
export async function guardarColumnasDeAjuste(clave, alAbrir, editadas) {
  const ajustes = await getAgencySettings();
  const final = fusionarColumnas(alAbrir, editadas, ajustes?.[clave]);
  const guardado = await updateAgencySettings({ [clave]: final });
  return normalizeColumns(guardado?.[clave] ?? final);
}
